import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../../services/notification.service';
import { passwordValidator } from '../../../validators/input-validators';
import { ResponseObject } from '../../../../common/interfaces/global-interfaces';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrl: './recover-password.component.scss'
})
export class RecoverPasswordComponent implements OnInit {
  resetForm: FormGroup;
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private notificationService = inject(NotificationService);
  hide = true;
  loading = false;
  requestToken = this.route.snapshot?.paramMap?.get('token');


  ngOnInit(): void {
    this.resetForm = this.fb.group({
      requestToken: [this.requestToken, Validators.required],
      password: [null, [Validators.required, Validators.pattern(passwordValidator)]],
      confirmPassword: [null, Validators.required],
    });
  }


  async resetPassword(formData: any) {
    this.loading = true;
    try {
      const response: ResponseObject = await this.authService.resetPassword({
        ...formData,
        confirmPassword: undefined,
      });
      if (response?.status === true) {
        this.notificationService.successSnackbar(response?.message);
        this.router?.navigate(['', 'login']);
      } else {
        this.notificationService.errorSnackbar(response?.message);
      }
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }

}
